module.exports = __webpack_public_path__ + "static/media/search_result.f118c717.svg";